
import {
    ADD_LEAD_APPLICANT,
    ADD_LEAD_APPLICANT_SUCCESS,
    ADD_LEAD_APPLICANT_ERROR,
    UPDATE_LEAD_APPLICANT,
    UPDATE_LEAD_APPLICANT_SUCCESS,
    UPDATE_LEAD_APPLICANT_ERROR,
    DELETE_LEAD_APPLICANT,
    DELETE_LEAD_APPLICANT_SUCCESS,
    DELETE_LEAD_APPLICANT_ERROR,

} from "./actionTypes"
export const addLeadApplicant = payload => {
    return {
        type: ADD_LEAD_APPLICANT,
        payload: payload,
    }
}

export const addLeadApplicantSuccess = lead => {
    return {
        type: ADD_LEAD_APPLICANT_SUCCESS,
        payload: lead,
    }
}

export const addLeadApplicantError = error => {
    return {
        type: ADD_LEAD_APPLICANT_ERROR,
        payload: error,
    }
}

export const updateLeadApplicant = payload => {
    return {
        type: UPDATE_LEAD_APPLICANT,
        payload: payload,
    }
}

export const updateLeadApplicantSuccess = lead => {
    return {
        type: UPDATE_LEAD_APPLICANT_SUCCESS,
        payload: lead,
    }
}

export const updateLeadApplicantError = error => {
    return {
        type: UPDATE_LEAD_APPLICANT_ERROR,
        payload: error,
    }
}

export const deleteLeadApplicant = payload => {
    return {
        type: DELETE_LEAD_APPLICANT,
        payload: payload,
    }
}

export const deleteLeadApplicantSuccess = lead => {
    return {
        type: DELETE_LEAD_APPLICANT_SUCCESS,
        payload: lead,
    }
}

export const deleteLeadApplicantError = error => {
    return {
        type: DELETE_LEAD_APPLICANT_ERROR,
        payload: error,
    }
}

  //Lead Applicants//